import React, { useEffect, useState } from "react";
import { Modal } from "rsuite";
import { MdAccessTimeFilled } from "react-icons/md";

const labelCls = "text-sm font-semibold text-gray-700 dark:text-gray-300";
const valueCls =
  "w-full rounded-xl border border-gray-200 bg-gray-50 px-3 py-2.5 text-sm font-medium text-navy-700 dark:border-white/10 dark:bg-navy-900 dark:text-white";

const ModalViewDetailHours: React.FC<any> = ({
  openHoursDetailModal,
  setOpenHoursDetailModal,
  details,
  updateState,
}) => {
  const [detail, setDetail] = useState<any>({});

  useEffect(() => {
    setDetail(details);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openHoursDetailModal]);

  const handleClose = () => {
    setOpenHoursDetailModal(false);
  };

  const isApproved = detail?.status === "Aprovada";

  return (
    <>
      <Modal open={openHoursDetailModal} size={"sm"} onClose={handleClose}>
        <Modal.Header>
          <Modal.Title>
            <div className="flex items-center gap-2.5">
              <span className="dv-aura flex h-9 w-9 items-center justify-center rounded-xl bg-dv-gradient text-white shadow-dv-glow">
                <MdAccessTimeFilled className="h-5 w-5" aria-hidden="true" />
              </span>
              <span className="text-lg font-bold text-navy-700 dark:text-white">
                Detalhes do Apontamento
              </span>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-1.5">
              <label htmlFor="detail-employee" className={labelCls}>
                Colaborador
              </label>
              <input
                id="detail-employee"
                disabled
                value={detail?.nmEmployee ?? ""}
                className={valueCls}
              />
            </div>
            <div className="flex flex-col gap-1.5">
              <label htmlFor="detail-project" className={labelCls}>
                Projeto
              </label>
              <input
                id="detail-project"
                disabled
                value={detail?.nmProject ?? ""}
                className={valueCls}
              />
            </div>
            <div className="flex flex-col gap-1.5">
              <label htmlFor="detail-client" className={labelCls}>
                Cliente
              </label>
              <input
                id="detail-client"
                value={detail?.nmCorporate ?? ""}
                disabled
                className={valueCls}
              />
            </div>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <div className="flex flex-col gap-1.5">
                <label htmlFor="detail-hours" className={labelCls}>
                  Total de horas
                </label>
                <input
                  id="detail-hours"
                  value={detail?.totalHours ?? ""}
                  disabled
                  className={`${valueCls} tabular-nums`}
                />
              </div>
              <div className="flex flex-col gap-1.5">
                <span className={labelCls}>Status</span>
                <div className="flex items-center">
                  <span
                    className={`rounded-full px-2.5 py-1 text-[11px] font-semibold ${
                      isApproved
                        ? "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300"
                        : "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300"
                    }`}
                  >
                    {isApproved ? "Aprovada" : "Pendente"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default ModalViewDetailHours;
